import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@everway/design-system-react";
import { saveCalendarSettings } from "../../redux/actions/Calendar/saveCalendarSettingsAction";
import { disconnectCalendar } from "../../redux/actions/Calendar/disconnectCalendarAction";
import { useNavigate } from "react-router-dom";
import axios from "../../api/axiosConfig";
import { Capacitor } from "@capacitor/core";
import { useIsMobile as useIsMobileHook } from "../../hooks/useIsMobile";
import { getItem, removeItem } from "../../utils/storageHelper";

const CalendarSettings = (props) => {
    const { onClose } = props;
    const dispatch = useDispatch();
    const userCalendarSettings = useSelector((state) => state.userCalendarSettings);
    const [providerName, setProviderName] = useState('Disconnect Calendar'); 
    const navigate = useNavigate();

    // --- 1. CREATE A REF FOR THE DIALOG ---
    const disconnectDialogRef = useRef(null);
    const isMobile = useIsMobileHook();

    const [settings, setSettings] = useState(userCalendarSettings);
    const [permanentlyRemove, setPermanentlyRemove] = useState(false);
    const [showDisconnectButtons, setShowDisconnectButtons] = useState(false);
    const [showConnectCalendar, setShowConnectCalendar] = useState(false);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const newValue = type === "checkbox" ? checked : value;
        const updatedSettings = { ...settings, [name]: newValue };
        setSettings(updatedSettings);
        dispatch(saveCalendarSettings(updatedSettings));
    };

    const showMonthView = () => {
        if (isMobile) {
            return false;
        } else {
            return true;
        }
    };

    const goToCalendarPage = () => {

        navigate("/Calendar");

        onClose();
    };


    useEffect(() => {
    const calendarProviderName = async () => {
        let provider = await getItem("calendarProvider");

       

        if (provider) {
            if (provider === 'microsoft') {
                setProviderName("Microsoft Outlook");
            } else {
                setProviderName('Google Calendar');
            }
        } else {
            setProviderName("Calendar");
            setShowConnectCalendar(true);
        }
        };
        calendarProviderName();
}, []);

    const [isDisconnecting, setIsDisconnecting] = useState(false);

    // This internal handler will show the spinner and then call the parent's confirm logic.
    const handleConfirmDisconnect = async () => {
        setIsDisconnecting(true);
        try {
            const params = { PermanentlyRemove: permanentlyRemove };
            await dispatch(disconnectCalendar( params));
            console.log("Calendar disconnected successfully.");
            setShowDisconnectButtons(false);
            setShowConnectCalendar(true);
            await removeItem("calendarProvider");
        } catch (error) {
            console.error("Failed to disconnect calendar:", error);
            alert(`Error: ${error.message}`);
        } finally {
            // Reset spinner state regardless of outcome.
            setIsDisconnecting(false);
        }
    };
    const handleDisconnectToggle = () => {
        setShowDisconnectButtons(!showDisconnectButtons);
    }

    const close = () => {

    };

    const showDisconnect = () => {
        const provider = getItem("calendarProvider") ?? 'unknown';

        if (provider === 'unknown') {
            return false;
        } else {
            return true;
        }
    };

    const handleExpireRefreshToken = async () => {

        console.log("Expiring Refresh Token");
        // This will force the backend to expire the refresh token, simulating a token expiry scenario.
        //fetch('/api/calendar/expire-refresh-token', { method: 'POST' })
        //    .then(response => {
        //        if (response.ok) {
        //            alert('Refresh token expired. You will need to reconnect your calendar.');
        //        } else {
        //            alert('Failed to expire refresh token.');
        //        }
        //    })
        //    .catch(error => {
        //        console.error('Error expiring refresh token:', error);
        //        alert('An error occurred while expiring the refresh token.');
        //    });
        try {
            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/editRefreshToken`,
                { permanentlyRemove: permanentlyRemove },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status == '200') {
                alert('Refresh token expired. You will need to reconnect your calendar.');
            } else {
                alert('Failed to expire refresh token.');
            }
        }
        catch (error) {
            console.error("edit refresh token - " + error);
        }


    }

    return (
        <div className="gw-settings-main__body gw-settings-body">
            <p>Calendar</p>
            {/* No Calendar connected*/}
            {showConnectCalendar && (
                <div className="eds-banner eds-banner--information edu-flex edu-align-center edu-p-l edu-m-2xl">
                    <svg xmlns="http://www.w3.org/2000/svg" className="edu-shrink-0">
                        <use href="#globaltasks-svg-info" />
                    </svg>
                    <div className="eds-banner__content edu-flex-1">
                        <p className="eds-banner__title" style={{ margin: 0, fontWeight: 'bold', color: "black" }}>Connect a calendar to unlock settings</p>
                        <p style={{ margin: 0, color: "black" }}>Connect a calendar to access options to customise your calendar's style and more.</p>
                    </div>
                    <Button variant="secondary" size="sm" onClick={onClose}>Connect calendar</Button>
                </div>
            )}
            {/* Default Calendar View */}
            { showMonthView() && (
            <div className="gw-settings-body__row">
                <div className="gw-settings-field">
                    <label className="gw-settings-field__label">Default Calendar View</label>
                    <select
                            className="gw-select"
                            name="defaultView"
                            value={userCalendarSettings.defaultView}
                            onChange={handleChange}
                            disabled={showConnectCalendar}
                    >
                        <option value="Day">Day</option>
                        <option value="Week">Week</option>
                        <option value="Month">Month</option>
                    </select>
                </div>
                </div>
            )}
            {/* Time Format */}
            <div className="gw-settings-body__row">
                <div className="gw-settings-field">
                    <label className="gw-settings-field__label">Time Format</label>
                    <select
                        className="gw-select"
                        name="timeFormat"
                        value={userCalendarSettings.timeFormat}
                        onChange={handleChange}
                        disabled={showConnectCalendar}
                    >
                        <option value="TwelveHour">12-hour time</option>
                        <option value="TwentyFourHour">24-hour time</option>
                    </select>
                </div>
            </div>
            {/* Default event duration */}
            <div className="gw-settings-body__row">
                <div className="gw-settings-field">
                    <label className="gw-settings-field__label">Default event duration</label>
                    <select
                        className="gw-select"
                        name="eventDuration"
                        value={userCalendarSettings.eventDuration}
                        onChange={handleChange}
                        disabled={showConnectCalendar}
                    >
                        <option value="Minutes15">15 minutes</option>
                        <option value="Minutes20">20 minutes</option>
                        <option value="Minutes30">30 minutes</option>
                        <option value="Minutes45">45 minutes</option>
                        <option value="Minutes55">55 minutes</option>
                        <option value="Hour1">1 hour</option>
                        <option value="Hour1Minutes30">1 hour 30 minutes</option>
                        <option value="Hours2">2 hours</option>
                    </select>
                </div>
            </div>
            {/* Start the week on */}
            <div className="gw-settings-body__row">
                <div className="gw-settings-field">
                    <label className="gw-settings-field__label">Start the week on</label>
                    <select
                        className="gw-select"
                        name="weekDayStartOn"
                        value={userCalendarSettings.weekDayStartOn}
                        onChange={handleChange}
                        disabled={showConnectCalendar}
                    >
                        <option value="Monday">Monday</option>
                        <option value="Tuesday">Tuesday</option>
                        <option value="Wednesday">Wednesday</option>
                        <option value="Thursday">Thursday</option>
                        <option value="Friday">Friday</option>
                        <option value="Saturday">Saturday</option>
                        <option value="Sunday">Sunday</option>
                    </select>
                </div>
            </div>
            {/* Show Weekends */}
            <div className="gw-settings-body__row">
                <div className="gw-checkbox">
                    <input
                        type="checkbox"
                        className="gw-checkbox__input"
                        id="showWeekends-label"
                        name="showWeekends"
                        checked={userCalendarSettings.showWeekends}
                        onChange={handleChange}
                        disabled={showConnectCalendar}
                    />
                </div>
                <label className="gw-checkbox__input-label" htmlFor="showWeekends-label">
                    Show Weekends
                </label>
            </div>
            {!showConnectCalendar ? (
                <>
                    {/* Disconnect Google Calendar Section */}
                    {!showDisconnectButtons ? (
                        <>
                            <div className="gw-settings-body__row">
                                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                                    <Button
                                        size="xs"
                                        variant="secondary"
                                        onClick={() => handleDisconnectToggle()}
                                    >
                                        Disconnect {providerName}
                                    </Button>
                                </div>
                            </div>
                            <div className="gw-settings-body__row">
                                <div className="edu-flex edu-flex-row edu-justify-start">
                                    <svg xmlns="http://www.w3.org/2000/svg" height={10} width={30}>
                                        <use href="#globaltasks-svg-error" />
                                    </svg>
                                    <span>This disconnects Global Tasks from any associated calendars in the app.</span>
                                </div>
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                <></>
            )}


            {showDisconnectButtons ? (
                <>
                    <p>
                        If you disconnect your calendar, you can always reconnect it again in the future.
                    </p>
                    <div className="gw-checkbox" style={{ marginTop: '20px', textAlign: 'left' }}>
                        <input
                            type="checkbox"
                            className="gw-checkbox__input"
                            id="permanently-remove"
                            checked={permanentlyRemove}
                            onChange={(e) => setPermanentlyRemove(e.target.checked)}
                        />
                        <label className="gw-checkbox__input-label" htmlFor="permanently-remove">
                            Permanently remove my Global Tasks and Timetable calendars from {providerName}
                        </label>
                    </div>

                    <div>
                        <div className="edu-flex edu-justify-end edu-gap-m" style={{ padding: '16px 24px', borderTop: '1px solid #eee' }}>
                            <Button variant="secondary" size="xs" onClick={() => handleDisconnectToggle()} >Cancel</Button>
                            <Button variant="destructive" size="xs" onClick={() => handleConfirmDisconnect()} >
                                {isDisconnecting ? 'Disconnecting...' : 'Disconnect'}
                            </Button>
                        </div>
                    </div>

                    <div>
                        {/*<div className="edu-flex edu-justify-end edu-gap-m" style={{ padding: '16px 24px', borderTop: '1px solid #eee' }}>*/}
                        {/*    <Button*/}
                        {/*        size="xs"*/}
                        {/*        variant="secondary"*/}
                        {/*        onClick={() => handleExpireRefreshToken()}*/}
                        {/*    >*/}
                        {/*        Expire RefreshToken*/}
                        {/*    </Button>*/}
                        {/*</div>*/}
                    </div>
                </>
            ) : (<></>)}

            {/* --- 4. RENDER THE MODAL AND PASS THE REF AND HANDLERS --- */}
            {/*<DisconnectModal*/}
            {/*    ref={disconnectDialogRef}*/}
            {/*    onConfirm={handleConfirmDisconnect}*/}
            {/*    onClose={() => disconnectDialogRef.current?.close()}*/}
            {/*    isPermanentlyRemoving={permanentlyRemove}*/}
            {/*    onSetPermanentlyRemoving={setPermanentlyRemove}*/}
            {/*/>*/}
        </div>
    );
};

export default CalendarSettings;
